import MuiCheckbox from '@mui/material/Checkbox';

import type { CheckboxProps } from 'ui/checkbox/checkbox.types';
import ControlLabel from 'ui/control-label';

const Checkbox = ({
  label,
  size = 'medium',
  disabled,
  sx,
  ref,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  ...rest
}: CheckboxProps) => {
  const inputProps = {
    ref,
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
  };
  const control = (
    <MuiCheckbox
      {...rest}
      size={size}
      disabled={disabled}
      sx={label === undefined ? sx : undefined}
      slotProps={{ input: inputProps }}
    />
  );

  if (label === undefined) {
    return control;
  }

  return (
    <ControlLabel
      control={control}
      label={label}
      size={size}
      disabled={disabled}
      sx={sx}
    />
  );
};

export default Checkbox;
